export default "__VITE_ASSET__CFMI2YIO__"